import { render, staticRenderFns } from "./freezer-spec-code.vue?vue&type=template&id=1987dfd5&scoped=true&"
import script from "./freezer-spec-code.vue?vue&type=script&lang=js&"
export * from "./freezer-spec-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1987dfd5",
  null
  
)

export default component.exports